import React, { Component } from 'react'
import { Modal } from 'react-bootstrap';

class ModalResult extends Component {

  getIcon = (variant) => {
    let Icon;

    switch(variant) {
      case 'error':
        Icon = <svg viewBox="0 0 22 22" data-icon="exclamation-circle" width="1em" height="1em"><circle cx="11" cy="-1041.36" r="11" transform="matrix(1 0 0-1 0-1030.36)" opacity=".98" fill="#da4453"/><path d="m-26.309 18.07c-1.18 0-2.135.968-2.135 2.129v12.82c0 1.176.948 2.129 2.135 2.129 1.183 0 2.135-.968 2.135-2.129v-12.82c0-1.176-.946-2.129-2.135-2.129zm0 21.348c-1.18 0-2.135.954-2.135 2.135 0 1.18.954 2.135 2.135 2.135 1.181 0 2.135-.954 2.135-2.135 0-1.18-.952-2.135-2.135-2.135z" transform="matrix(.30056 0 0 .30056 18.902 1.728)" fill="#fff" stroke="#fff"/></svg>;
      break;

      case 'warning':
        Icon = <svg viewBox="64 64 896 896" focusable="false" data-icon="warning" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"></path></svg>;
      break;

      case 'success':
        Icon = <svg viewBox="64 64 896 896" focusable="false" data-icon="check-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"></path></svg>;
      break;

      default:
        Icon = <svg viewBox="64 64 896 896" focusable="false" data-icon="exclamation-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"></path></svg>;
      break;
    }

    return <span role="img" className="icon">{ Icon }</span>;
  }

  render() {
    const { className = '', title, subtitle, icon, children, backdrop = 'static', keyboard = false, extra, status = 'success' } = this.props;
    const variant = `result-${status}`;
    const Icon = icon;

    return (
      <Modal
        show={ true }
        backdrop={ backdrop }
        keyboard={ keyboard }
        centered={ true }
        onHide={ window.noop }
      >

        <Modal.Body>
            <div className={ `${className}  result ${variant}` }>
              <div className="result-icon">
                { !!icon ? Icon : this.getIcon(status) }
              </div>

              <div className="result-title">{ title }</div>
              { !!subtitle &&  <div className="result-subtitle">{ subtitle }</div> }
              { !!children && <div className="result-content">{ children }</div> }
              { !!extra && <div className="result-extra">{ extra }</div> }
            </div>
        </Modal.Body>

      </Modal>
    )
  }
}

export default ModalResult;